import React from 'react'

const ErrorIcon = () => {
    return (
        <svg
            //  width="24" height="24" 
            style={{ width: '100%' }}
            viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.96798 4.16592C10.8536 2.61136 13.1464 2.61136 14.032 4.16592L21.7041 17.6324C22.5649 19.1433 21.4445 21 19.6721 21H4.32789C2.55546 21 1.4351 19.1433 2.29587 17.6324L9.96798 4.16592ZM12.9999 17C12.9999 17.5523 12.5522 18 11.9999 18C11.4477 18 10.9999 17.5523 10.9999 17C10.9999 16.4477 11.4477 16 11.9999 16C12.5522 16 12.9999 16.4477 12.9999 17ZM12.7499 9C12.7499 8.58579 12.4142 8.25 11.9999 8.25C11.5857 8.25 11.2499 8.58579 11.2499 9V14C11.2499 14.4142 11.5857 14.75 11.9999 14.75C12.4142 14.75 12.7499 14.4142 12.7499 14V9Z" fill="#D92D20" />
        </svg>

    )
}

export default ErrorIcon